<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Quejas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">Consulta de quejas</p>
      </div>
      <b-row>
        <b-col>
          <div class="barra">
            <b-row>
              <div class="col-sm-12 col-md-4 d-flex text-left">
                <font-awesome-icon
                    style="color: gray"
                    class="m-auto m-1"
                    icon="filter"
                />
                <b-form-input
                    class="ml-3 input-filter"
                    placeholder="Nombre"
                    v-model="filtro.nombre"
                ></b-form-input>
              </div>

              <div class="col-sm-10 col-md-7 text-right">
                <b-dropdown
                    @hide="search.clasificacionSearch = ''"
                    variant="ligth"
                    id="dropdown-offset"
                    :text="texClasificacion"
                >
                  <!--                    <div class="m-2">-->
                  <!--                      <b-form-input id="input-small" size="sm" v-model="search.clasificacionSearch" placeholder="Clasificación"></b-form-input>-->
                  <!--                    </div>-->
                  <!--                    <b-dropdown-divider></b-dropdown-divider>-->
                  <div class="contenedor-drop">
                    <b-form-group class="m-2" v-slot="{ ariaDescribedby }">
                      <b-form-radio
                          v-for="option in clasificacionFiltro"
                          v-model="filtro.clasificaciones"
                          :key="option.value"
                          :value="option"
                          :aria-describedby="ariaDescribedby"
                          name="flavour-3a"
                          @input="obtenerEtapas()"
                      >
                        {{ option.description }}
                      </b-form-radio>
                    </b-form-group>

                    <!--                      <b-form-checkbox-group-->
                    <!--                          class="m-2"-->
                    <!--                          v-model="filtro.clinicas"-->
                    <!--                          :options="clinicasFiltro"-->
                    <!--                          text-field="strNombre"-->
                    <!--                          name="clinica"-->
                    <!--                      >-->
                    <!--                      </b-form-checkbox-group>-->
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                      class="text-right"
                      @click="
                        limpiar('clasificacionSearch', 'clasificaciones', [])
                      "
                  >
                    <em class="fa fa-close"></em> Limpiar
                  </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown
                    @hide="search.etapaSearch = ''"
                    variant="ligth"
                    id="dropdown-offset"
                    :text="texEtapa"
                >
                  <div class="m-2">
                    <b-form-input
                        id="input-small"
                        size="sm"
                        v-model="search.etapaSearch"
                        placeholder="Etapa"
                    ></b-form-input>
                  </div>
                  <div class="contenedor-drop">
                    <b-form-group class="m-2" v-slot="{ ariaDescribedby }">
                      <b-form-checkbox
                          v-for="option in etapasFiltro"
                          v-model="filtro.estatus"
                          :key="option.value"
                          :value="option"
                          :aria-describedby="ariaDescribedby"
                          name="flavour-3a"
                      >
                        {{ option.descripcion }}
                      </b-form-checkbox>
                    </b-form-group>

                    <!--                      <b-form-checkbox-group-->
                    <!--                          class="m-2"-->
                    <!--                          v-model="filtro.clinicas"-->
                    <!--                          :options="clinicasFiltro"-->
                    <!--                          text-field="strNombre"-->
                    <!--                          name="clinica"-->
                    <!--                      >-->
                    <!--                      </b-form-checkbox-group>-->
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                      class="text-right"
                      @click="limpiar('etapaSearch', 'estatus', [])"
                  >
                    <em class="fa fa-close"></em> Limpiar
                  </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown
                    @hide="search.etapaSearch = ''"
                    variant="ligth"
                    id="dropdown-offset"
                    :text="texEstatus"
                >
                  <div class="m-2">
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <div class="contenedor-drop">
                    <b-form-group class="m-2" v-slot="{ ariaDescribedby }">
                      <b-form-checkbox
                          v-for="option in estatus"
                          v-model="filtro.estatusEtapa"
                          :key="option.idEstatusEtapa"
                          :value="option"
                          :aria-describedby="ariaDescribedby"
                          name="flavour-3a"
                      >
                        {{ option.descripcion }}
                      </b-form-checkbox>
                    </b-form-group>

                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                      class="text-right"
                      @click="limpiar(null, 'estatusEtapa', [])"
                  >
                    <em class="fa fa-close"></em> Limpiar
                  </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown
                    @hide="search.clinicaSearch = ''"
                    variant="ligth"
                    id="dropdown-offset"
                    :text="texClinica"
                >
                  <div class="m-2">
                    <b-form-input
                        id="input-small"
                        size="sm"
                        v-model="search.clinicaSearch"
                        placeholder="Clínica"
                    ></b-form-input>
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <div class="contenedor-drop">
                    <b-form-group class="m-2" v-slot="{ ariaDescribedby }">
                      <b-form-checkbox
                          v-for="option in clinicasFiltro"
                          v-model="filtro.clinicas"
                          :key="option.value"
                          :value="option"
                          :aria-describedby="ariaDescribedby"
                          name="flavour-3a"
                      >
                        {{ option.strNombre }}
                      </b-form-checkbox>
                    </b-form-group>

                    <!--                      <b-form-checkbox-group-->
                    <!--                          class="m-2"-->
                    <!--                          v-model="filtro.clinicas"-->
                    <!--                          :options="clinicasFiltro"-->
                    <!--                          text-field="strNombre"-->
                    <!--                          name="clinica"-->
                    <!--                      >-->
                    <!--                      </b-form-checkbox-group>-->
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                      class="text-right"
                      @click="limpiar('clinicaSearch', 'clinicas', [])"
                  >
                    <em class="fa fa-close"></em> Limpiar
                  </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown
                    variant="ligth"
                    id="dropdown-fechai"
                    :text="texFechaInicio"
                    class="btn-filter"
                >
                  <b-calendar
                      class="m-2"
                      v-model="filtro.fechaInicio"
                      :max="new Date()"
                      locale="en-US"
                  ></b-calendar>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                      class="text-right"
                      @click="limpiar(null, 'fechaInicio', null)"
                  >
                    <em class="fa fa-close"></em> Limpiar
                  </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown
                    variant="ligth"
                    id="dropdown-fechaf"
                    :text="texFechaFin"
                    class="btn-filter"
                >
                  <b-calendar
                      class="m-2"
                      v-model="filtro.fechaFin"
                      :min="
                        filtro.fechaInicio === null
                          ? new Date()
                          : filtro.fechaInicio
                      "
                      :max="new Date()"
                      locale="en-US"
                  ></b-calendar>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                      class="text-right"
                      @click="limpiar(null, 'fechaFin', null)"
                  >
                    <em class="fa fa-close"></em> Limpiar
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
              <div class="col-md-1  col-sm-12 text-right">
                <span class="btn-clear" @click="limpiarFiltro()"><em class="fa fa-close"></em></span>
                <b-button
                    variant="primary"
                    :disabled="loader"
                    @click="obtenerDatos()"
                >
                  <span v-if="!loader"
                  ><font-awesome-icon icon="search"
                  /></span>
                  <span v-else><b-spinner small></b-spinner></span>
                </b-button>
              </div>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <div style="margin-top:2%; overflow: auto">
         <b-table
              id="Pendientes"
              thead-tr-class="columnas"
               empty-filtered-text="Sin resultados"

              :items="lista"
              :fields="columnas"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              >
            <template v-slot:cell(idTicket)="row">
              <a @click="obtnerMovimientos(row.item)">{{row.item.idTicket}}</a>
            </template>
            <template v-slot:cell(comentarios)="row">
              <p @click="abrirModalComentario(row.item.comentarios)"  class="overflow-ellipsis">
                {{row.item.comentarios}}
              </p>
            </template>
            <template v-slot:cell(fechaRecepcion)="row">
                {{row.item.fechaRecepcion | formatoFechaHora}}
            </template>
            <template v-slot:cell(fechaSla1)="row">
                {{row.item.fechaSla1 | formatoFechaHora}}
            </template>
            <template v-slot:cell(semaforo)="row">
                <b-icon style="color: #00AA33" icon="circle-fill"></b-icon>
            </template>
          </b-table>


           <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <div v-if="!loader">
            <b-alert v-if="lista.length === 0" variant="warning" show>No se encontraron registros</b-alert>
          </div>
          <div v-if="!loader">
            <b-pagination
                v-if="lista.length > 15"
                align="center"
                v-model="paginaActual"
                :total-rows="lista.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </div>



      </div>

    </b-card>
    <b-modal size="xl" v-model="showModal" title="Tracking">
      <div
          style="
            background-color: #0e6ba9;
            height: 50px;
            line-height: 50px;
            text-align: center;
          "
      >
        <p
            v-if="solicitudSeleccionada != null"
            style="color: white; font-size: 20px; font-weight: 600"
        >
          ID: {{ solicitudSeleccionada.idTicket }} Clasificación:
          {{ solicitudSeleccionada.clasificacion }} Fecha:
          {{ solicitudSeleccionada.fechaRecepcion | formatoFechaHora }}
        </p>
      </div>
      <div style="margin: 2%">
        <b-row>
          <b-col md="7">
            <b-card>
              <p style="font-size: 18px; font-weight: 600; color: #5a84ca">
                Etapas
              </p>
              <div style="width: 80%" class="scroll">
                <ul class="text-left" v-if="movimientos.length > 0">
                  <li
                      v-for="(item, index) in movimientos"
                      :key="'movimientos' + index"
                  >
                    <b-card
                        style="
                          box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
                        "
                    >
                      <div
                          v-b-toggle="'accordion-productdetails' + index"
                          style="display: flex; flex-direction: row"
                      >
                        <b-row>
                          <b-col md="2" class="text-center">
                            <img
                                width="80%"
                                style="max-width: 100%"
                                src="../../../assets/icons/historial-medico.png"
                                v-bind:alt="previewImage"
                            />
                          </b-col>

                          <b-col md="10">
                            <div>
                              <p style="font-size: 16px; font-weight: 600">
                                {{ item.movimiento }}
                              </p>

                              <p style="margin-top: -15px; color: #948986">
                                {{ item.fechaAlta | formatoFechaHora }}
                              </p>
                              <span>
                                {{ item.comentarios }}
                              </span>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-card>
                  </li>
                </ul>
              </div>
            </b-card>
          </b-col>
          <b-col md="5">
            <b-card>
              <div>
                <p style="font-size: 18px; font-weight: 600; color: #5a84ca">
                  Solicitudes padre
                </p>
                <div v-if="!isObjEmpty(subsecuente)">
                  <b-card
                      style="
                        box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
                      "
                      @click="obtnerMovimientos(subsecuente)"
                  >
                    <div style="display: flex; flex-direction: row">
                      <b-row>
                        <b-col md="2" class="text-center">
                          <img
                              width="100%"
                              style="max-width: 100%"
                              src="../../../assets/icons/historial-dental.png"
                          />
                        </b-col>

                        <b-col md="10">
                          <div>
                            <p style="font-size: 16px; font-weight: 600">
                              ID: {{ subsecuente.idTicket }}
                            </p>
                            <p
                                style="
                                  margin-top: -15px;
                                  font-size: 16px;
                                  font-weight: 600;
                                "
                            >
                              Padre: {{ subsecuente.clasificacion }}
                            </p>

                            <p style="margin-top: -15px; color: #948986">
                              {{
                                subsecuente.fechaRecepcion | formatoFechaHora
                              }}
                            </p>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </div>
                <div v-else>
                  <p style="font-size: 16px; font-weight: 600">
                    Esta solicitud es una solicitud padre
                  </p>
                </div>
              </div>
              <div>
                <p
                    style="
                      margin-top: 10%;
                      font-size: 18px;
                      font-weight: 600;
                      color: #5a84ca;
                    "
                >
                  Solicitudes hijo
                </p>
                <div class="text-left" v-if="hijosSolicitud.length > 0">
                  <li
                      v-for="(item, index) in hijosSolicitud"
                      :key="'hijosSolicitud' + index"
                  >
                    <b-card
                        @click="obtnerMovimientos(item)"
                        style="
                          box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
                        "
                    >
                      <div style="display: flex; flex-direction: row">
                        <b-row>
                          <b-col md="2" class="text-center">
                            <img
                                width="100%"
                                style="max-width: 100%"
                                src="../../../assets/icons/chequeo-medico.png"
                            />
                          </b-col>

                          <b-col md="10">
                            <div>
                              <p style="font-size: 16px; font-weight: 600">
                                ID: {{ item.idTicket }}
                              </p>
                              <p
                                  style="
                                    margin-top: -15px;
                                    font-size: 16px;
                                    font-weight: 600;
                                  "
                              >
                                Hijo: {{ item.clasificacion }}
                              </p>

                              <p style="margin-top: -15px; color: #948986">
                                {{ item.fechaRecepcion | formatoFechaHora }}
                              </p>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-card>
                  </li>
                </div>
                <div v-else>
                  <p style="font-size: 16px; font-weight: 600">
                    Esta solicitud no cuenta con solicitudes hijo
                  </p>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
        v-model="modalComentarios"
        title="Comentarios del paciente"
        scrollable
        size="xl"
    >
      <p style="font-size: 18px; font-weight: 600; ">El paciente comenta:</p>
      <div class="container-fluid main-component p-3 text-justify">

        <p>{{comentario}}</p>
      </div>
    </b-modal>


  </div>
</template>

<script>
import {GarantiaService} from "../../../apiServices/garantias/GarantiaService";
import Header from "../../../components/Header";
import {MotorService} from "../../../apiServices/motor/MotorService";
import {CatalogosService} from "../../../apiServices/catalogos/CatalogosService";

export default {
  name: "GarantiasIndex",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      motorServicio: new MotorService(),
      garantiaServicio: new GarantiaService(),
      catalogoServicio: new CatalogosService(),
      loader: false,
      lista: [],

      filtro: {
        estatusEtapa: [ { idEstatusEtapa: 1, descripcion: "Pendiente" },],
        estatus: [],
        clinicas: [],
        clasificaciones: null,
        nombre: null,
        fechaInicio: null,
        fechaFin: null,
      },
      search: {
        clinicaSearch: "",
        etapaSearch: "",
        clasificacionSearch: "",
      },

      paginaActual:1,
      registrosPorPagina: 15,
      columnas :[
        {key: "idTicket", label: "ID", sortable: true},
        {key: "fechaRecepcion", label: "Fecha Recepción", sortable: true},
        {key: "fechaSla1", label: "Fecha SLA1", sortable: true},
        {key: "semaforo", label: "Semaforo", sortable: true},
        {key: "estatus", label: "Estatus", sortable: true},
        {key: "atiende", label: "Responsable", sortable: true},
        {key: "origen", label: "Medio Recepción", sortable: true},
        {key: "clasificacion", label: "Tipo Clasifición", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "idPaciente", label: "ID Paciente", sortable: true},
        {key: "paciente", label: "Nombre del Px", sortable: true},
        {key: "comentarios", label: "Comentarios", sortable: true},
      ],
      movimientos: [],
      subsecuente: {},
      hijosSolicitud: [],
      solicitudSeleccionada: null,
      showModal: false,

      clasificaciones: [],
      origenes: [],
      clinicas: [],
      etapas: [],
      comentario: null,
      modalComentarios: false,
      estatus: [
        { idEstatusEtapa: 1, descripcion: "Pendiente" },
        { idEstatusEtapa: 2, descripcion: "En proceso" },
        { idEstatusEtapa: 3, descripcion: "Finalizado" },
      ],
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerDatos()
    this.obtenerClasificaciones();
    this.obtenerOrigenes();
    this.obtenerEtapas();
    this.obtnerClinicas();
  },
  methods: {
    isObjEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }

      return true;
    },
    agregar(){
      this.$router.push({name: "garantiaAlta"})
    },
    obtenerDatos(){
      this.loader = true;
      this.lista=[]
      this.garantiaServicio.obtenerQuejas(this.datosEnvio())
      .then(respuesta => {
        this.lista = respuesta.data;
      })
      .finally(()=>{
        this.loader = false;
      })
    },
    siguenteFlujo(idSolicitud){
      const params = {
        idSolicitudEtapa: idSolicitud,
        objeto: null
      }
      this.motorServicio.obtenerSiguenteFlujo(params)
          .then(respuesta => {
            let url = respuesta.data.urlPantalla
            if (respuesta.data.parametros.length > 0) {
              url = url + '/';
              respuesta.data.parametros.forEach((p, i) => {
                url = url + p.valor
                if (i + 1 < respuesta.data.parametros.length) {
                  url = url + '/';
                }
              })
            }
            this.$router.push(url)
          })
          .finally(() => {
            this.loader = false;
          })
    },

    obtnerMovimientos(solicitud) {
      //pao
      if (solicitud != null) {
        this.solicitudSeleccionada = solicitud;
        const buscarHijos = this.lista.filter(
            (element) => element.idSolicitudPadre == solicitud.idTicket
        );
        this.hijosSolicitud = buscarHijos;
        if (solicitud.idSolicitudPadre != null) {
          this.subsecuente = solicitud.idSolicitudPadre;
          const buscarClasificacionPadre = this.lista.find(
              (element) => element.idTicket == this.subsecuente
          );
          this.clasificacionSubsecuente =
              buscarClasificacionPadre.clasificacion;
          const subsecuente = {
            idTicket: solicitud.idSolicitudPadre,
            clasificacion: buscarClasificacionPadre.clasificacion,
            fechaRecepcion: buscarClasificacionPadre.fechaRecepcion,
          };
          this.subsecuente = subsecuente;
        } else {
          this.subsecuente = {};
        }
      }
      const params = {
        idSolicitud: solicitud.idTicket
      }
      this.motorServicio
          .obtenerMovimientos(params)
          .then((respuesta) => {
            this.movimientos = respuesta.data;
            this.showModal = true;
          })
          .finally(() => {
            this.loader = false;
          });
    },

    abrirModalComentario(comentario){
      this.comentario = comentario
      this.modalComentarios = true
    },


    datosEnvio() {
      const envio = JSON.parse(JSON.stringify(this.filtro));

      if (this.filtro.fechaInicio !== null && this.filtro.fechaInicio != "") {
        let fechaActual = this.$moment(this.filtro.fechaInicio).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        });
        envio.fechaInicio = fechaActual
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {
        let fechaActual = this.$moment(new Date()).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        });
        envio.fechaInicio = fechaActual
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      }
      if (this.filtro.fechaFin !== null && this.filtro.fechaFin != "") {
        let fechaF = this.$moment(this.filtro.fechaFin).set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999,
        });
        envio.fechaFin = fechaF.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {
        let fechaF = this.$moment(new Date()).set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999,
        });
        envio.fechaFin = fechaF.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      }
      if (this.filtro.clinicas.length > 0) {
        envio.clinicas = this.filtro.clinicas.map((t) => t.idClinica);
      } else {
        envio.clinicas = null;
      }
      if (this.filtro.estatus.length > 0) {
        envio.estatus = this.filtro.estatus.map((t) => t.id);
      } else {
        envio.estatus = null;
      }
      if (this.filtro.estatusEtapa.length > 0) {
        envio.estatusEtapa = this.filtro.estatusEtapa.map((t) => t.idEstatusEtapa);
      } else {
        envio.estatusEtapa = null;
      }
      if (
          this.filtro.clasificaciones != null &&
          this.filtro.clasificaciones != ""
      ) {
        envio.clasificaciones = [this.filtro.clasificaciones.idClasificacion];
      } else {
        envio.clasificaciones = null;
      }
      return envio;
    },
    obtenerClasificaciones() {
      this.catalogoServicio.obtenerClasificacionesUsuario().then((response) => {
        this.clasificaciones = response.data;
      });
    },
    obtenerOrigenes() {
      this.garantiaServicio.obtenerOrigenQuejas().then(response => {
        this.origenes = response.data;
      })
    },

    obtenerEtapas() {
      this.loader = true;
      const id =
          this.filtro.clasificaciones != null && this.filtro.clasificaciones != ""
              ? this.filtro.clasificaciones.idClasificacion
              : 5;
      const params = {
        idClasificacion: id
      }
      this.motorServicio
          .obtenerEtapasPorClasificacion(params)
          .then((respuesta) => {
            this.etapas = respuesta.data;
          })
          .finally(() => {
            this.loader = false;
          });
    },
    obtnerClinicas() {
      this.catalogoServicio.listaClinicas().then((response) => {
        this.clinicas = response;
      });
    },


    limpiar(search, atriburo, valor) {
      if (search != null) {
        this.search[search] = "";
      }
      this.filtro[atriburo] = valor;
    },
    limpiarFiltro() {
      this.filtro = {
        estatus: [],
        clinicas: [],
        clasificaciones: null,
        nombre: null,
        fechaInicio: null,
        fechaFin: null,
      };
    },

  },
  computed: {
    clinicasFiltro() {
      return this.clinicas.filter((item) => {
        return item.strNombre
            .toLowerCase()
            .includes(this.search.clinicaSearch.toLowerCase());
      });
    },
    etapasFiltro() {
      return this.etapas.filter((item) => {
        return item.descripcion
            .toLowerCase()
            .includes(this.search.etapaSearch.toLowerCase());
      });
    },
    clasificacionFiltro() {
      return this.clasificaciones.filter((item) => {
        return item.description
            .toLowerCase()
            .includes(this.search.clasificacionSearch.toLowerCase());
      });
    },
    texClinica() {
      let text = "Clinicas";

      if (this.filtro.clinicas.length === 1) {
        text = this.filtro.clinicas[0].strNombre;
      }
      if (this.filtro.clinicas.length > 1) {
        text =
            this.filtro.clinicas[0].strNombre +
            " (" +
            (this.filtro.clinicas.length - 1) +
            "+" +
            ")";
      }
      return text;
    },
    texEtapa() {
      let text = "Etapa";
      if (this.filtro.estatus.length === 1) {
        text = this.filtro.estatus[0].descripcion;
      }
      if (this.filtro.estatus.length > 1) {
        text =
            this.filtro.estatus[0].descripcion +
            " (" +
            (this.filtro.estatus.length - 1) +
            "+" +
            ")";
      }
      return text;
    },
    texEstatus() {
      let text = "Estatus";
      if (this.filtro.estatusEtapa.length === 1) {
        text = this.filtro.estatusEtapa[0].descripcion;
      }
      if (this.filtro.estatusEtapa.length > 1) {
        text =
            this.filtro.estatusEtapa[0].descripcion +
            " (" +
            (this.filtro.estatusEtapa.length - 1) +
            "+" +
            ")";
      }
      return text;
    },
    texClasificacion() {
      let text = "Clasificaciones";
      // if (this.filtro.clasificaciones.length === 1) {
      //   text = this.filtro.clasificaciones[0].description
      // }
      // if (this.filtro.estatus.length > 1){
      //   text = this.filtro.clasificaciones[0].description + ' ('+(this.filtro.clasificaciones.length-1)+'+'+ ')'
      // }
      if (
          this.filtro.clasificaciones != null &&
          this.filtro.clasificaciones != ""
      ) {
        text = this.filtro.clasificaciones.description;
      }
      return text;
    },
    texFechaInicio() {
      return this.filtro.fechaInicio === null || this.filtro.fechaInicio === ""
          ? "Fecha Inicio"
          : this.filtro.fechaInicio;
    },
    texFechaFin() {
      return this.filtro.fechaFin === null || this.filtro.fechaFin === ""
          ? "Fecha Fin"
          : this.filtro.fechaFin;
    },
  },
}
</script>

<style scoped>
.bCardGlobal{
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo{
  width: 100%;
  margin-top: 2%;
  border-bottom: 5px solid #8EC6E9;
}

.textSubtitulo{
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll {
  max-height: 500px;
  overflow-y: auto;
}

.barra {
  background: #e2e2e2;
  margin: 1rem;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
}

.row {
  background: transparent !important;
}

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}
.contenedor-drop {
  overflow: auto;
  max-height: 15em;
}

label {
  font-weight: 100 !important;
}

.btn-clear {
  color: gray;
  position: relative;
  margin-right: 1em;
}
.btn-clear:hover {
  color: black;
  cursor: pointer;
}
.btn-clear:focus {
  color: black;
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}

</style>
